module.exports = __webpack_public_path__ + "img/design-tech.aaab3c48.png";